import React from 'react';
import { useHistory } from 'react-router-dom';

import partnerEdu from '../../Resources/Images/Redesign/partner-edu.png';
import partnerModa from '../../Resources/Images/Redesign/partner-moda.svg';
import partnerNcku from '../../Resources/Images/Redesign/partner-ncku.png';
import partnerNtu from '../../Resources/Images/Redesign/partner-ntu.svg';
import partnerNtust from '../../Resources/Images/Redesign/partner-ntust.png';
import partnerYuntech from '../../Resources/Images/Redesign/partner-yuntech.jpg';
import partnerCmu from '../../Resources/Images/Redesign/partner-cmu.jpg';

interface Partner {
  name: string;
  en: string;
  tag: string;
  url: string;
  logo: string;
  desc: string;
}

const GOV_PARTNERS: Partner[] = [
  {
    name: '教育部',
    en: 'Ministry of Education',
    tag: '指導機關',
    url: 'https://www.edu.tw',
    logo: partnerEdu,
    desc: '主管全國教育事務，委託建置「數位證明管理中心」，推動大專校院數位證書與數位憑證制度。',
  },
  {
    name: '數位發展部',
    en: 'Ministry of Digital Affairs',
    tag: '合作推動機關',
    url: 'https://moda.gov.tw',
    logo: partnerModa,
    desc: '推動國家數位信任架構與數位轉型，合作介接數位憑證皮夾（Digital Wallet）與分散式識別標準。',
  },
];

const UNI_PARTNERS: Partner[] = [
  {
    name: '國立成功大學',
    en: 'National Cheng Kung University',
    tag: '執行建置學校',
    url: 'https://www.ncku.edu.tw',
    logo: partnerNcku,
    desc: '受教育部委託負責數位證明管理中心之整體規劃、發證驗證技術研發及跨校整合推廣。',
  },
  {
    name: '國立臺灣大學',
    en: 'National Taiwan University',
    tag: '合作大專校院',
    url: 'https://www.ntu.edu.tw',
    logo: partnerNtu,
    desc: '參與數位學位證書與數位憑證制度介接，推動校園數位證明查驗與多元跨域應用。',
  },
  {
    name: '國立臺灣科技大學',
    en: 'National Taiwan University of Science and Technology',
    tag: '合作大專校院',
    url: 'https://www.ntust.edu.tw',
    logo: partnerNtust,
    desc: '共同推進技職體系數位證書發行、憑證皮夾應用與跨校數位證明流通實作。',
  },
  {
    name: '國立雲林科技大學',
    en: 'National Yunlin University of Science and Technology',
    tag: '合作大專校院',
    url: 'https://www.yuntech.edu.tw/',
    logo: partnerYuntech,
    desc: '加入本中心合作大專校院，共同推動數位證明服務發展。',
  },
  {
    name: '中國醫藥大學',
    en: 'China Medical University, Taiwan',
    tag: '合作大專校院',
    url: 'https://www.cmu.edu.tw/',
    logo: partnerCmu,
    desc: '加入本中心合作大專校院，共同推動數位證明服務發展。',
  },
];

export const PartnersPage: React.FC = () => {
  const history = useHistory();

  const renderCard = (p: Partner) => (
    <article key={p.name} className="dc-partner-card">
      <div className="dc-partner-logo">
        <img src={p.logo} alt={`${p.name}標誌`} loading="lazy" />
      </div>
      <div className="dc-partner-header">
        <div className="dc-partner-title-wrap">
          <h3>{p.name}</h3>
          <small className="dc-partner-en">{p.en}</small>
        </div>
        <span className="dc-partner-tag">{p.tag}</span>
      </div>
      <p className="dc-partner-desc">{p.desc}</p>
      <div className="dc-partner-footer">
        <a
          href={p.url}
          target="_blank"
          rel="noopener noreferrer"
          className="dc-button dc-partner-btn"
        >
          前往官方網站 ↗
        </a>
      </div>
    </article>
  );

  return (
    <>
      <h1>合作單位</h1>
      <p className="dc-lead">
        攜手政府機關與全國大專校院，共同建置安全可信的數位證書與數位憑證生態系。
      </p>

      <h2>主管與合作推動機關</h2>
      <div className="dc-partner-grid">{GOV_PARTNERS.map(renderCard)}</div>

      <h2>合作大專校院</h2>
      <div className="dc-partner-grid">{UNI_PARTNERS.map(renderCard)}</div>

      <div className="dc-actions">
        <button
          type="button"
          className="dc-button"
          onClick={() => history.push('/about')}
        >
          回到中心介紹
        </button>
        <button
          type="button"
          className="dc-button"
          onClick={() => history.push('/about/architecture')}
        >
          查看服務架構
        </button>
        <button
          type="button"
          className="dc-button"
          onClick={() => history.push('/about/faq')}
        >
          查看常見問題
        </button>
      </div>
    </>
  );
};

export default PartnersPage;
